import type { CSSProperties } from 'react'

type BrandStackProps = {
  onSignIn: () => void
}

const SANS_STACK =
  "system-ui, -apple-system, 'Segoe UI Variable Display', 'SF Pro Display', 'Helvetica Neue', Arial, sans-serif"
const MONO_STACK = "ui-monospace, 'SF Mono', 'Cascadia Code', 'Consolas', Menlo, monospace"

const positionedAbsolute = (bottom: string): CSSProperties => ({
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 10,
  bottom,
  userSelect: 'none',
})

export function BrandStack({ onSignIn }: BrandStackProps) {
  return (
    <>
      <div
        style={{
          ...positionedAbsolute('96px'),
          fontFamily: SANS_STACK,
          fontWeight: 200,
          fontSize: '19px',
          letterSpacing: '14px',
          paddingLeft: '14px',
          color: 'rgba(255,255,255,0.85)',
        }}
      >
        ALEPH
      </div>

      <button
        type="button"
        onClick={onSignIn}
        aria-label="Bei Aleph anmelden"
        style={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 10,
          bottom: '38px',
          fontFamily: SANS_STACK,
          fontWeight: 600,
          fontSize: '14px',
          letterSpacing: '0.5px',
          padding: '11px 30px',
          background: 'white',
          color: '#0a0a0f',
          border: 'none',
          borderRadius: '999px',
          boxShadow: '0 0 28px rgba(255,255,255,0.18)',
          cursor: 'pointer',
        }}
      >
        Anmelden
      </button>

      <div
        style={{
          ...positionedAbsolute('14px'),
          fontFamily: MONO_STACK,
          fontSize: '9px',
          letterSpacing: '2px',
          color: 'rgba(255,255,255,0.42)',
        }}
      >
        BY ECONWORKS
      </div>
    </>
  )
}
